import React from "react";
import { useTranslation } from "react-i18next";
import { CheckCircle2, Clock, XCircle } from "lucide-react";

/**
 * Compact verification badge for jobs / employer cards.
 * status: 'verified' | 'pending' | 'rejected' | undefined
 */
export default function VerifiedBadge({ status, size = "sm" }) {
  const { t } = useTranslation();
  if (!status || status === "rejected") return null;

  if (status === "verified") {
    return (
      <span
        className={`inline-flex items-center gap-1 ${size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-1"} rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 font-medium`}
        title={t("verified.title")}
        data-testid="verified-badge"
      >
        <CheckCircle2 className={size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} />
        {t("verified.label")}
      </span>
    );
  }

  if (status === "pending") {
    return (
      <span
        className={`inline-flex items-center gap-1 ${size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-1"} rounded-full bg-slate-50 text-slate-500 border border-slate-200 font-medium`}
        title={t("verified.pending_title")}
        data-testid="pending-badge"
      >
        <Clock className={size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} />
        {t("verified.pending_label")}
      </span>
    );
  }

  return null;
}
